import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaTasks, FaCubes, FaFoursquare } from "react-icons/fa";
import { IoIosArrowDown, IoMdSettings } from "react-icons/io";
import { GoDash } from "react-icons/go";
import { IoColorFilterOutline } from "react-icons/io5";
import { BsFiletypeRaw } from "react-icons/bs";
import { SiCloudfoundry } from "react-icons/si";
import { AiFillQqCircle } from "react-icons/ai";
import { LiaGitlab } from "react-icons/lia";
import { TbBrandProducthunt } from "react-icons/tb";
import {
  MdDashboardCustomize,
  MdKeyboardDoubleArrowLeft,
} from "react-icons/md";
import { RiArrowRightDoubleFill } from "react-icons/ri";
import Logo from "../../images/logo/logo.png";
import Logo1 from "../../images/logo/logo1.png";
import { GiSwallow } from "react-icons/gi";

const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
  sidebarCollapsed,
  setSidebarCollapsed,
}) => {
  const location = useLocation();
  const { pathname } = location;
  const sidebarRef = useRef(null);
  const [openGroups, setOpenGroups] = useState({});
  const [activeFloatingMenu, setActiveFloatingMenu] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setActiveFloatingMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuClick = (key) => {
    if (sidebarCollapsed) {
      setActiveFloatingMenu(activeFloatingMenu === key ? null : key);
    } else {
      setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const menuGroups = [
    {
      key: "master",
      label: "Master",
      icon: <MdDashboardCustomize />,
      children: [{ label: "Master", path: "/master" }],
    },
    {
      key: "die-management",
      label: "Die Management",
      icon: <FaTasks />,
      children: [{ label: "Die Master", path: "/die-management/die-master" }],
    },
    {
      key: "die-allocation",
      label: "Die Allocation",
      icon: <GiSwallow />,
      children: [
        { label: "Die Allocation", path: "/die-management/die-allocation" },
      ],
    },
    {
      key: "sales-order",
      label: "Sales Order",
      icon: <FaCubes />,
      children: [{ label: "Orders", path: "/sales-orders/order-master" }],
    },
    {
      key: "order-plan",
      label: "Order Plan",
      icon: <IoColorFilterOutline />,
      children: [{ label: "Order Plan View", path: "/order-plan-view" }],
    },
    {
      key: "raw-material",
      label: "Raw Material",
      icon: <BsFiletypeRaw />,
      children: [
        { label: "Material Inward", path: "/material-inward" },
        { label: "All Stocks", path: "/all-stock" },
      ],
    },
    {
      key: "foundry",
      label: "Foundry",
      icon: <FaFoursquare />,
      children: [{ label: "Foundry", path: "/foundry" }],
    },
    {
      key: "inProduction",
      label: "In Production",
      icon: <TbBrandProducthunt />,
      children: [{ label: "In Prod", path: "/in-production" }],
    },
    {
      key: "qc",
      label: "QC",
      icon: <AiFillQqCircle />,
      children: [{ label: "QC", path: "/qc" }],
    },
    {
      key: "aging",
      label: "Aging",
      icon: <LiaGitlab />,
      children: [{ label: "Aging", path: "/aging" }],
    },
    {
      key: "packing",
      label: "Packing",
      icon: <SiCloudfoundry />,
      children: [{ label: "Packing", path: "/packing" }],
    },
    {
      key: "settings",
      label: "Settings",
      icon: <IoMdSettings />,
      children: [
        { label: "Menu-Permission", path: "/settings/menu-permission" },
      ],
    },
  ];

  return (
    <aside
      ref={sidebarRef}
      className={`fixed top-0 left-0 z-50 h-screen flex flex-col bg-[#8e9bb2] text-white shadow-2xl transition-all duration-300 
  ${sidebarCollapsed ? "w-16" : "w-56"} ${
    sidebarOpen ? "translate-x-0" : "-translate-x-full"
  } lg:translate-x-0`}
    >
      <div className="flex h-16 items-center justify-center border-b border-white/20 shrink-0">
        <NavLink to="/">
          <img
            src={sidebarCollapsed ? Logo1 : Logo}
            alt="Logo"
            className="h-8 w-auto"
          />
        </NavLink>
      </div>

      <nav className="flex-1 mt-4 px-2 space-y-1 overflow-y-auto no-scrollbar relative">
        {menuGroups.map((group) => {
          const hasSubmenu = group.children && group.children.length > 1;
          const isOpen = openGroups[group.key];
          const isFloatingOpen = activeFloatingMenu === group.key;

          const menuContent = (
            <div className="flex items-center gap-3 relative group">
              <span className="text-xl shrink-0">{group.icon}</span>
              {!sidebarCollapsed && (
                <span className="text-sm font-medium truncate">
                  {group.label}
                </span>
              )}

              {sidebarCollapsed && (
                <div
                  className="fixed left-16 ml-2 px-3 py-2 bg-[#1e293b] text-white text-xs rounded-md 
                  opacity-0 invisible group-hover:opacity-100 group-hover:visible 
                  transition-all duration-200 whitespace-nowrap z-[9999] shadow-xl border border-white/10"
                >
                  {group.label}

                  <div
                    className="absolute top-1/2 -left-1.5 -translate-y-1/2 
                    border-y-[6px] border-y-transparent 
                    border-r-[6px] border-r-[#1e293b]"
                  ></div>
                </div>
              )}
            </div>
          );

          return (
            <div key={group.key} className="relative">
              {hasSubmenu ? (
                <button
                  onClick={() => handleMenuClick(group.key)}
                  className={`group relative w-full flex items-center justify-between p-3 rounded-lg transition-colors hover:bg-white/10 ${
                    isOpen && !sidebarCollapsed ? "bg-white/5" : ""
                  }`}
                >
                  {menuContent}
                  {!sidebarCollapsed && (
                    <IoIosArrowDown
                      className={`transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  )}
                </button>
              ) : (
                <NavLink
                  to={group.children[0].path}
                  className={({ isActive }) =>
                    `group relative w-full flex items-center p-3 rounded-lg transition-colors hover:bg-white/10 ${
                      isActive ? "bg-white/20 text-yellow-400" : ""
                    }`
                  }
                >
                  {menuContent}
                </NavLink>
              )}

              {!sidebarCollapsed && hasSubmenu && isOpen && (
                <ul className="mt-1 ml-4 border-l border-white/10 pl-2 space-y-1">
                  {group.children.map((item, idx) => (
                    <li key={idx}>
                      <NavLink
                        to={item.path}
                        className={({ isActive }) =>
                          `flex items-center gap-2 p-2 rounded-md text-xs hover:text-yellow-400 ${
                            isActive
                              ? "text-yellow-400 font-bold"
                              : "text-white"
                          }`
                        }
                      >
                        <GoDash /> {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}

              {sidebarCollapsed && hasSubmenu && isFloatingOpen && (
                <div className="fixed left-[70px] mt-[-45px] z-[9999] w-48 bg-[#1e293b] rounded-lg shadow-2xl border border-white/10 py-2">
                  <div className="px-4 py-2 text-xs font-bold text-gray-400 uppercase border-b border-white/5 mb-2">
                    {group.label}
                  </div>
                  <ul className="space-y-1">
                    {group.children.map((item, idx) => (
                      <li key={idx}>
                        <NavLink
                          onClick={() => setActiveFloatingMenu(null)}
                          to={item.path}
                          className="flex items-center gap-2 px-4 py-2 text-xs text-gray-300 hover:text-yellow-400 hover:bg-white/5 transition-all"
                        >
                          <GoDash size={10} /> {item.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className="p-2 border-t border-white/20 shrink-0">
        <button
          onClick={() => {
            setSidebarCollapsed(!sidebarCollapsed);
            setActiveFloatingMenu(null);
            localStorage.setItem("sidebar-expanded", !sidebarCollapsed);
          }}
          className="w-full flex items-center justify-center p-2 hover:bg-white/10 rounded-lg text-white font-bold hover:text-white"
        >
          {sidebarCollapsed ? (
            <RiArrowRightDoubleFill size={24} />
          ) : (
            <MdKeyboardDoubleArrowLeft size={24} />
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
